import { DateTime } from "luxon";

/**
 * Returns the current datetime in the utc time
 *
 * @returns A Luxon `DateTime` object with current datetime
 *
 */
export const DateTimeNow = () => {
  return DateTime.now().setZone("utc");
};

/**
 * Returns the datetime in the utc timezone
 *
 * @param ISOstring - Datetime ISO string
 * @returns A Luxon `DateTime` object with datetime based on an ISO string
 *
 */
export const DateTimeISO = (ISOstring: string) => {
  const timeUTC = DateTime.fromISO(ISOstring, {
    zone: "utc",
  });

  return timeUTC;
};
